import { useContext, useState } from "react";
import { NavLink, Navigate } from "react-router-dom";

// IMPORTS
import PATH_IMG_BUSMEN from '../img/busmen.PNG';
import undefinidUser from '../img/userUndefinid.jpg';
import { AuthContext } from "../Global/AuthContext";
import {TT_TEXT_PO, TYPE_THEME} from "../Constants/Const";
import { ThemeComponent } from "../Global/Theme";

/** MUI */
import { styled, useTheme } from '@mui/material/styles';
import { Avatar, Button, Grid, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import RateReviewIcon from '@mui/icons-material/RateReview';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { CompareArrows, ThumbUpAlt, Diversity3, CalendarMonth, Logout } from '@mui/icons-material';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';

// #region MUI MENU
const drawerWidth = 240;

const openedMixin = (theme) => ({
      width: drawerWidth,
      transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
      }),
      overflowX: 'hidden',
});

const closedMixin = (theme) => ({
      transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: `calc(${theme.spacing(7)} + 1px)`,
      [theme.breakpoints.up('sm')]: {
      width: `calc(${theme.spacing(8)} + 1px)`,
      },
});

const DrawerHeader = styled('div')(({ theme }) => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
      
      ...theme.mixins.toolbar,
}));


const AppBar = styled(
            MuiAppBar,
            { shouldForwardProp: (prop) => prop !== 'open' }
      )(({ theme, open }) => ({
      zIndex: theme.zIndex.drawer + 1, transition: theme.transitions.create(['width', 'margin'],
            {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
            }),
      ...(open && {
            marginLeft: drawerWidth,
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
            }),
      }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

// #endregion MUI MENU

export default function MiniDrawer({children}){

      const {logged, exit, dataUser, theme} = useContext(AuthContext);
      const themeDefault = useTheme();
      const [selectedIndex, setSelectedIndex] = useState(0);
      const [anchorEl, setAnchorEl] = useState(null);
      const [open, setOpen] = useState(false);

      const openMenuUser = Boolean(anchorEl);

      const handlingChangeReport = (index) => {
            setSelectedIndex(index);
      }

      const DATA_REPORTS = [
            {
                  name: 'Pre Orden',
                  icon: <CompareArrows />,
                  tooltip: <Typography>{TT_TEXT_PO.pre_order}</Typography>,
                  path: "/Pre-Orden"
            },
            {
                  name: 'Confirmar Orden',
                  icon: <ThumbUpAlt />,
                  tooltip: <Typography>{TT_TEXT_PO.confirm}</Typography>,
                  path: "/Confirmar-Orden"
            },
            {
                  name: 'Orden de Trabajo',
                  icon: <Diversity3 />,
                  tooltip: <Typography>{TT_TEXT_PO.work_order}</Typography>,
                  path: "/Orden-Trabajo"
            },
            {
                  name: "Talleres",
                  icon: <HomeRepairServiceIcon />,
                  tooltip: <Typography>{TT_TEXT_PO.map_mechanical}</Typography>,
                  path: "/Talleres"
            },
            {
                  name: "Calendario",
                  icon: <CalendarMonth/>,
                  tooltip: <Typography>{TT_TEXT_PO.calendar}</Typography>,
                  path: "/Calendario"
            },
            {
                  name: "Manuales",
                  icon: <LibraryBooksIcon />,
                  tooltip: <Typography>{TT_TEXT_PO.manual}</Typography>,
                  path: "/Manual"
            },
            {
                  name: "Diagramas",
                  icon: <AccountTreeIcon/>,
                  tooltip: <Typography>{TT_TEXT_PO.diagram}</Typography>,
                  path: "/Diagrama"
            },
            {
                  name: "Chat Taller",
                  icon: <RateReviewIcon/>,
                  tooltip: <Typography>{TT_TEXT_PO.chat}</Typography>,
                  path: "/Chat"
            }
      ];

      const handleDrawerOpen = () => {
            setOpen(true);
      };
      
      const handleDrawerClose = () => {
            setOpen(false);
      };

      const handleCloseMenu = () => {
            setAnchorEl(null);
      };
      const handleOpenUserMenu = (event) => {
            setAnchorEl(event.currentTarget);
      };


      return(
            logged?
            <Box sx={{ display: 'flex' }}>
                  <CssBaseline />
                  {/* # region BAR */}
                  <AppBar position="fixed" open={open}>
                        <Toolbar>
                              <IconButton color="inherit"
                                    aria-label="open drawer"
                                    onClick={handleDrawerOpen}
                                    edge="start"
                                    sx={{
                                    marginRight: 5,
                                    ...(open && { display: 'none' }),
                                    }}>
                                          <MenuIcon/>
                              </IconButton>
                              <Grid container direction="row"
                                    justifyContent="flex-end" alignItems="flex-start">
                                    <Typography style={{marginTop: "10px", marginRight: "20px"}}>
                                          {`Bienvenido ${dataUser?.id_usuario}`}
                                    </Typography>
                                    <Tooltip title="Abrir opciones del usuario">
                                          <IconButton sx={{ p:0 }} onClick={handleOpenUserMenu}>
                                                <Avatar style={{backgroundColor: theme.MUI === TYPE_THEME.light? null:"rgb(255,255,255"}}
                                                        alt="Imagen Usuario" src={undefinidUser} />
                                          </IconButton>
                                    </Tooltip>
                                    <Menu anchorEl={anchorEl}
                                          open={openMenuUser}
                                          onClose={handleCloseMenu} >
                                                <MenuItem>Perfil</MenuItem>
                                                <MenuItem onClick={()=>exit()}>Salir</MenuItem>
                                    </Menu>
                              </Grid>
                        </Toolbar>
                  </AppBar>
                  {/* # endregion BAR */}

                  {/* # region DRAWER MENU */}
                  <Drawer variant="permanent" open={open}>
                        <DrawerHeader>
                              <ThemeComponent/>

                              <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center">
                                          <Typography ariant="h1">Menu</Typography>
                              </Grid>

                              <IconButton onClick={handleDrawerClose}>
                                    {themeDefault.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                              </IconButton>
                              
                        </DrawerHeader>

                        <Divider />
                        
                        <List>
                              {
                                    DATA_REPORTS.map((dataRow, index)=>(
                                          <Tooltip key={dataRow.name}  title={dataRow.tooltip} placement="right">
                                                <NavLink to={dataRow.path} style={{color: "black", textDecoration: "black"}}>
                                                      <ListItem disablePadding sx={{ display: 'block' }}>
                                                            <ListItemButton
                                                                  //disabled={index > 2}
                                                                  selected={selectedIndex === index}
                                                                  onClick={() => handlingChangeReport(index)}
                                                                  sx={{
                                                                        minHeight: 48,
                                                                        justifyContent: open ? 'initial' : 'center',
                                                                        px: 2.5,
                                                                  }}>
                                                                        <ListItemIcon sx={{
                                                                              minWidth: 0,
                                                                              mr: open ? 3 : 'auto',
                                                                              justifyContent: 'center',
                                                                              }}>
                                                                                    {dataRow.icon}
                                                                        </ListItemIcon>
                                                                        
                                                                              <ListItemText
                                                                                  primary={dataRow.name}
                                                                                  sx={{ opacity: open ? 1 : 0,
                                                                                        color: theme.MUI === TYPE_THEME.light? "rgb(0,0,0)":"rgb(255,255,255)"
                                                                              }}/>
                                                            </ListItemButton>
                                                      </ListItem>
                                                </NavLink>
                                          </Tooltip>
                                    ))
                              }
                        </List>

                        <Divider />
                        
                        <Tooltip title="Cerrar session">
                              <Button variant={open?"contained":"outlined"} color="error"  size="small"
                                    startIcon={<Logout />} style={{marginTop: "2vh"}}
                                    onClick={()=>exit()}>

                              </Button>
                        </Tooltip>

                  </Drawer>
                  {/* # endregion DRAWER MENU */}

                  <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                        <DrawerHeader/>
                        <Grid container
                              direction="row"
                              justifyContent="center"
                              alignItems="center" m={3}>
                              <img src={PATH_IMG_BUSMEN} alt="BUSMEN imagen" width={'170vh'} height={'65vh'}/>
                        </Grid>
                        {/*<RoutersComponent/>*/}
                        {children}
                  </Box>


            </Box>:<Navigate to="/Login" />
      );
}